import { attrs, createEvent } from '../event-store';

export interface ChartCsvPlanAttributes {
  chartToken: string;
  plan: any; // Not importing actual type due to linter restrictions
  rowCount: number;
  datasetColumnCount: number;
  datasetRowCount: number;
  switchViewToken: string;
}

export interface ViewDataCsvPlanAttributes {
  plan: any; // Not importing actual type due to linter restrictions
  rowCount: number;
  datasetColumnCount: number;
  datasetRowCount: number;
  switchViewToken: string;
}

const CSV_EXPORT_TRACENAME = 'helix-csv-export';

export const generateDesignerCsvPlan = createEvent(
  CSV_EXPORT_TRACENAME,
  'generate-report-plan',
  attrs<ChartCsvPlanAttributes>()
);
export const generateReportCsvPlan = createEvent(
  CSV_EXPORT_TRACENAME,
  'generate-designer-plan',
  attrs<ChartCsvPlanAttributes>()
);
export const generateViewDataCsvPlan = createEvent(
  CSV_EXPORT_TRACENAME,
  'generate-view-data-plan',
  attrs<ViewDataCsvPlanAttributes>()
);

export const csvExportSuccess = createEvent(
  CSV_EXPORT_TRACENAME,
  'csv-export-success',
  attrs<{ token: string; refId: string; isRetry: boolean }>()
);
export const csvExportFailed = createEvent(
  CSV_EXPORT_TRACENAME,
  'csv-export-failed',
  attrs<{ token: string; refId: string; err: Error; isRetry: boolean }>()
);

export const designerCsvExportClick = createEvent(
  CSV_EXPORT_TRACENAME,
  'designer-export-clicked',
  attrs<{ token: string }>()
);
export const reportCsvExportClick = createEvent(
  CSV_EXPORT_TRACENAME,
  'report-export-clicked',
  attrs<{ token: string }>()
);
export const viewDataCsvExportClick = createEvent(
  CSV_EXPORT_TRACENAME,
  'view-data-export-clicked',
  attrs<{ token: string }>()
);

export const downloadClick = createEvent('download-export', 'download-click');
export const downloadSuccess = createEvent('download-export', 'download-success', attrs<{ downloadSize: number }>());
export const downloadFailed = createEvent('download-export', 'download-failed', attrs<{ err: Error }>());

export type GenerateCsvPlanEvents =
  | typeof generateDesignerCsvPlan
  | typeof generateReportCsvPlan
  | typeof generateViewDataCsvPlan;

export type HelixCsvExportEvents =
  | typeof generateDesignerCsvPlan
  | typeof generateReportCsvPlan
  | typeof generateViewDataCsvPlan
  | typeof csvExportSuccess
  | typeof csvExportFailed
  | typeof designerCsvExportClick;
